<template>
    <base-nav class="navbar-top navbar-dark"
              id="navbar-main"
              :show-toggle-button="false"
              expand>
        <ul class="align-items-center navbar-nav d-none ml-md-auto d-md-flex">
          <language-dropdown class="nav-item dropdown mr-1" />
          <user-info-dropdown class="nav-item dropdown" />
        </ul>
    </base-nav>
</template>
<script>
import UserInfoDropdown from '../components/UserInfoDropdown'
import LanguageDropdown from '../components/LanguageDropdown'
export default {
  components: { UserInfoDropdown, LanguageDropdown },
  data() {
    return {
      activeNotifications: false,
      showMenu: false,
      searchQuery: ''
    }
  },
  methods: {
    toggleSidebar() {
      this.$sidebar.displaySidebar(!this.$sidebar.showSidebar);
    },
    hideSidebar() {
      this.$sidebar.displaySidebar(false);
    },
    toggleMenu() {
      this.showMenu = !this.showMenu;
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/layout/DashboardNavbar.vue